<div *ngIf="loading$ | async; else loading">
  <div *ngIf="alumno$ | async as alumno">
    <div class="responsive feedback-student-bar">
      <div class="student-tools">
        <div class="student-tools__1">
          <button mat-icon-button color="primary" (click)="navegarAtras()" matTooltip="Regresar a lista de alumnos">
            <mat-icon>group</mat-icon>
          </button>
          <div class="user-chip-cont">
            <div class="user-img-cont" *ngIf="alumno.imageUrl; else icono_usuario">
              <img src="{{alumno.imageUrl}}" class="user-img">
            </div>
            <ng-template #icono_usuario>
              <mat-icon>account_circle</mat-icon>
            </ng-template>
            <mat-form-field appearance="standard" class="full-width">
              <mat-label>Alumno</mat-label>
              <mat-select [formControl]="alumnoForm">
                <mat-option *ngFor="let alumno of alumnos" [value]="alumno.id">
                  {{alumno.apellidosNombres}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="student-tools__2">
          <app-retroalimentacion-grid-classroom-estado [submission]="alumno.submission" [alumno$]="alumno$"
            [devuelto]="true">
          </app-retroalimentacion-grid-classroom-estado>
          <button mat-icon-button (click)="indexChange(-1)">
            <mat-icon style="opacity: .6;" class="cursor-pointer">navigate_before</mat-icon>
          </button>
          <button mat-icon-button (click)="indexChange(1)">
            <mat-icon style="opacity: .6;" class="cursor-pointer">navigate_next</mat-icon>
          </button>
          <button mat-raised-button color="primary" [matMenuTriggerFor]="menuDevolver" class="student-actions-btn">
            Acciones
          </button>
          <mat-menu #menuDevolver="matMenu">
            <button mat-menu-item (click)="classroomAction(alumno, 'publicar')">Publicar</button>
            <button mat-menu-item (click)="classroomAction(alumno, 'despublicar')">Despublicar</button>
            <button *ngIf="alumno.devuelto" mat-menu-item (click)="classroomAction(alumno, 'publicar')">Configurar
              autoevaluacion</button>
          </mat-menu>
          <mat-slide-toggle [formControl]="mostrarAutoevaluacionForm" color="primary">Mostrar autoevaluación
          </mat-slide-toggle>
        </div>
        <div *ngIf="fechasEvento$ | async as fechasEvento" class="student-tools__3">
          <mat-form-field appearance="standard" class="full-width">
            <mat-label>Fecha</mat-label>
            <mat-select [formControl]="fechaForm">
              <mat-option *ngFor="let fecha of fechasEvento" [value]="fecha">
                {{fecha | date}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div *ngIf="archivos$ | async as archivos">
      <div *ngIf="archivos.length > 0; else noTrabajo" class="feedback-student-work">
        <div class="feedback-criteria-col">
          <mat-tab-group>
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon>comment</mat-icon>
              </ng-template>
              <div *ngIf="comentarioData$ | async as comentarioData">
                <glm-comentarios [comentarios]="comentarioData.comentarios" [targetID]="comentarioData.targetId"
                  [allowCreate]="true" [origen]="'unidadeventoalumno'"></glm-comentarios>
              </div>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon>assignment_turned_in</mat-icon>
              </ng-template>
              <app-retroalimentacion-trabajo-criterios [alumno$]="alumno$" [eventoUnidadId]="alumno.eventoUnidadId"
                [fechaActual$]="fechaActual$" [criterios]="criterios" [alumnos$]="alumnos$"
                [mostrarAutoevaluacion$]="mostrarAutoevaluacion$">
              </app-retroalimentacion-trabajo-criterios>
            </mat-tab>
          </mat-tab-group>
        </div>
        <div *ngIf="expandido$ | async as expandido" [ngClass]="{'feedback-assignment-viewer': !expandido.state}">
          <div *ngIf="archivos$ | async as archivos">
            <div *ngIf="archivos.length > 0; else noTrabajo">
              <div [ngClass]="{'fullscreen-iframe' : expandido.state}">
                <div class="student-work-selector">
                  <mat-form-field appearance="standard" class="full-width">
                    <mat-label>Seleccionar archivo</mat-label>
                    <mat-select [formControl]="archivoForm">
                      <mat-option *ngFor="let archivo of archivos" [value]="archivo.alternateLink">
                        {{archivo.title}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <button mat-icon-button color="primary" (click)="expandir(!expandido.state)" id="fullscreen-btn">
                    <mat-icon>{{expandido.state ? 'fullscreen_exit' : 'fullscreen'}}</mat-icon>
                  </button>
                </div>
                <div *ngIf="iframeSource$ | async as source">
                  <iframe sandbox="allow-scripts allow-same-origin" [src]="iframeSource"></iframe>
                  <!-- <embed [src]="url(archivoForm.value)" width=200 height=200> -->
                  <!-- <object type="text/html" [data]="url(archivoForm.value)" width="800px" height="600px" style="overflow:auto;border:5px ridge blue">
                    </object> -->
                  <!-- <link rel="import" [href]="url(archivoForm.value)"> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ng-template #noTrabajo>
        <div class="feedback-student-work">
          <app-retroalimentacion-trabajo-criterios [alumno$]="alumno$" [eventoUnidadId]="alumno.eventoUnidadId"
            [fechaActual$]="fechaActual$" [criterios]="criterios" [alumnos$]="alumnos$" [mostrarAutoevaluacion$]="mostrarAutoevaluacion$">
          </app-retroalimentacion-trabajo-criterios>
          <div *ngIf="comentarioData$ | async as comentarioData" class="noTrabajo__comm">
            <h3 class="mat-h3 noTrabajo__titles">
              <mat-icon>insert_comment</mat-icon>Comentarios
            </h3>
            <glm-comentarios [comentarios]="comentarioData.comentarios" [targetID]="comentarioData.targetId"
              [allowCreate]="true" [origen]="'unidadeventoalumno'"></glm-comentarios>
          </div>
        </div>
      </ng-template>

    </div>
  </div>
</div>
<ng-template #loading>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>
